import replaceAll from 'string.prototype.replaceall'

import styled from './styled'
import { getBaseReset } from './styles-system/create-component'
import * as presets from './themes'
import {
  getBorders as getBordersTheme,
  getGradients as getGradientsTheme,
  getShadows as getShadowsTheme
} from './themes/theme-keys'
import * as _utils from './utils'
export * from './themes/types'

// shim polyfill
replaceAll.shim()

//TODO: The `utils` object will not be tree shaken. If the application uses one function from `utils`, then the whole `utils` object will be bundled.
const utils = {
  ..._utils
}
export * from './utils/types'
export * from './themes/const'
export * from './theme-provider'
export * from './components'
export * from './_svg'
export * from './hooks'
export * from './components/_adaptors'
export { FontScales, SpaceScales, ScalesInfo } from './themes/scales'
export { defaultBreakpoints } from './themes/theme-keys/breakpoints'

export {
  getBaseReset,
  getBordersTheme,
  getGradientsTheme,
  getShadowsTheme,
  presets,
  styled,
  utils
}
